import classnames from 'classnames';
import type React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import ButtonLoading from '@/shared/ui/components/Loadings/buttonLoading';
import useNormalButton from './useNormalButton';

export type NormalButtonProps = {
  id?: string;
  isFilled?: boolean;
  isText?: boolean;
  isSaving?: boolean;
  disabled?: boolean;
  type?: string;
  buttonName: string | number;
  className?: string;
  style?: React.CSSProperties;
  hasIcon?: boolean;
  iconComponent?: React.ReactNode;
  isBold?: boolean;
  isLinkButton?: boolean;
  link?: string;
  onClick?: (e: React.MouseEvent) => void;
  target?: string;
  titleSaving?: string;
  contentClassName?: string;
  isDebounceClick?: boolean;
};

const NormalButton = ({
  id,
  isFilled = false,
  isText = false,
  isSaving = false,
  disabled = false,
  type = 'button',
  buttonName,
  className = '',
  style = {},
  hasIcon = false,
  iconComponent,
  isBold = false,
  isLinkButton = false,
  link = '',
  onClick = () => {},
  target,
  titleSaving,
  contentClassName,
  isDebounceClick = true,
}: NormalButtonProps) => {
  const { handleClick } = useNormalButton({ onClick, isDebounceClick });

  return isLinkButton ? (
    <Link
      id={id}
      className={classnames(
        'link-button',
        isFilled
          ? classnames('filled-btn', isSaving ? '--is-saving' : '')
          : isText
            ? classnames('text-btn', isBold ? '--bold' : '')
            : 'outline-btn',
        disabled ? '--disabled' : '',
        className,
      )}
      type={type}
      style={style}
      to={link}
      target={target}
    >
      <div className="flex justify-center">
        <span className={classnames('name', isSaving ? '--transparent' : '')}>
          {`${buttonName}`}
        </span>
        {hasIcon && iconComponent}
      </div>
    </Link>
  ) : (
    <button
      id={id}
      className={classnames(
        isFilled
          ? classnames('filled-btn', isSaving ? '--is-saving' : '')
          : isText
            ? classnames('text-btn', isBold ? '--bold' : '')
            : classnames('outline-btn', isSaving ? '--is-saving' : ''),
        disabled ? '--disabled' : '',
        className,
      )}
      type={type as 'button' | 'submit' | 'reset'}
      onClick={isSaving || disabled ? () => {} : handleClick}
      style={style}
    >
      <div className={classnames('flex justify-center', contentClassName)}>
        <span className={classnames('name', isSaving ? '--transparent' : '')}>
          {`${buttonName}`}
        </span>
        {hasIcon && iconComponent}
      </div>
      {isSaving && (
        <ButtonLoading
          title={titleSaving}
          className={className}
          isFilled={isFilled}
          shouldDisplayLoadingCursor
        />
      )}
    </button>
  );
};

export default NormalButton;
